import React from 'react';
import styled from 'styled-components';
import {CenteredDivWrap} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

// COLOR PALETTE
import {defaultTheme} from '@stencil/build-theme';

// ICONS
import GostaysIcon from '../../../../../../stories/Icons/Gostays';
import ArrowDownIcon from '../../../../../../stories/Icons/ArrowDownIcon';

// COMPONENTS
import {
  HiddenDropdownWrapperDiv,
  TipUI,
} from '../../../../../../stories/components/hotels/SRP/AmenitiesList/AmenitiesList.styles';

export const TipPositioning = styled(TipUI)(
  props => `
  top: 3.5rem;
  left: 7rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props.theme.colors.goBrandBlue.base};
    box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)}
      ${props.theme.colors.shadow.base};
  }
`,
);

export const CertifiedLabelHoverContainer = styled.div(
  props => `
  display:flex;
  background: ${props.theme.colors.goBrandBlue.base}
  border-radius: ${props.theme.misc.borderRadius.base};
  padding: ${props.theme.spacing.base};
  position: absolute;
  top: 4.7rem;
  z-index:99;
  min-width:22rem;
`,
);

export const CertifiedLabel = styled.div(
  props => `
  display: flex;
  align-items: center;
  position:relative;
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base} ${props.theme.spacing.small} ${
    props.theme.spacing.base
  };
  margin: 0 ${props.theme.spacing.custom(12)} 0 0;
  border-Radius: ${props.theme.misc.borderRadius.small};
  background-color: ${props.theme.colors.goBrandBlue.base}

  height: ${props.theme.spacing.custom(34)}
  max-height: ${props.theme.spacing.custom(34)}
  &:hover + ${CertifiedLabelHoverContainer}{
    visibility: visible;
  }
`,
);

export const CertifiedText = styled.span(
  props => `
  padding-left:${props.theme.spacing.small};
  color: ${props.theme.colors.goWhite.base};
  font-weight:bold;
`,
);

export const GostaysIconWrapper = styled.span(
  props => `
  position: relative;
  top: 2px;
  z-index: ${props.theme.misc.zIndex.base};

  &::after {
    content: '';
    position: absolute;
    top: -1px;
    right: -0.5px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: ${props.theme.colors.goWhite.base}
    z-index: -1;
  }
`,
);

export const CertifiedDetailsListWrap = styled.ul(
  props => `
  width:75%;
  list-style-type:none;
  padding-left:${props.theme.spacing.base};
  li{
      display:flex;
      align-items:center;
      color: ${props.theme.colors.goWhite.base};
      font-size:${props.theme.font.custom(14)};
      line-height:1.6;
      span{
        padding-left:${props.theme.spacing.small};
        width:95%;
      }
    }
`,
);

export const GostaysIconCertified = styled(CenteredDivWrap)(
  props => `
      width:5rem;
      height:5rem;
      background:  ${props.theme.colors.goWhite.base};
      border-radius: 50%;

  `,
);

export const ShowMoreLink = styled.a(
  props => `
  display: flex;
  width: fit-content;
  align-items: center;
  background:${props.theme.colors.goBrandBlue.dark}
  border-radius:${props.theme.misc.borderRadius.custom(9.5)};
  height:1.9rem;
  padding: 0 ${props.theme.spacing.large};
  margin-top:${props.theme.spacing.custom(8)};
  color:${props.theme.colors.goWhite.base};
  :visited {
    /* to over ride styles from combinedStyles.css*/
    color: ${props.theme.colors.goWhite.base}
  }
`,
);

export const goStaysSvgStyles = {
  width: '23px',
  height: '23px',
  fill: defaultTheme.colors.goBrandOrange.base,
  position: 'relative',
  top: '-1px',
};

export const arrowDownSvgStyles = {
  height: '6px',
  fill: defaultTheme.colors.goWhite.base,
};

export const ArrowDownIconWrapper = styled.div(
  props => `
  background: ${props.theme.colors.goBrandBlue.dark}
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin: 0 10px 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`,
);

export const GostaysKnowMoreLink = styled.a(
  props => `
  color: ${props.theme.colors.goWhite.base};

  :visited {
    /* to over ride styles from combinedStyles.css*/
    color: ${props.theme.colors.goWhite.base}
  }
`,
);

export const GostaysHoverHiddenDropdown = styled(HiddenDropdownWrapperDiv)`
  right: auto;
  cursor: pointer;
`;

export const LeftFacingUIIntentArrow = () => {
  const LeftFacingUIIntentArrowDiv = styled.div(
    props => `
    width: 0;
    height: 0;
    border-top: 21px solid transparent;
    border-bottom: 19px solid transparent;
    border-right: 8px solid ${props.theme.colors.goWhite.base};
  `,
  );

  const LeftFacingUIIntentArrowWrapper = styled.div`
    position: absolute;
    right: 0;
    top: -4px;
  `;

  return (
    <LeftFacingUIIntentArrowWrapper>
      <LeftFacingUIIntentArrowDiv />
    </LeftFacingUIIntentArrowWrapper>
  );
};

export const GostaysIconComponent = () => (
  <GostaysIconWrapper>
    <GostaysIcon {...goStaysSvgStyles} />
  </GostaysIconWrapper>
);

export const ArrowDown = () => (
  <ArrowDownIconWrapper>
    <ArrowDownIcon {...arrowDownSvgStyles} />
  </ArrowDownIconWrapper>
);
